import React, { useState, useRef } from "react";
import axios from "axios";
import { Paper, Button, CircularProgress, Typography } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';

function ProntuarioAsync() {
    const [transcription, setTranscription] = useState("");
    const [summary, setSummary] = useState("");
    const [loading, setLoading] = useState(false);
    const [recording, setRecording] = useState(false);
    const mediaRecorderRef = useRef(null);

    const sendAudioChunk = async (blob) => {
        console.log("Enviando chunk de áudio...");
        const reader = new FileReader();
        reader.onload = async () => {
            const audioData = reader.result;  // Dados binários do áudio
            try {
                // Envia o chunk de áudio para o backend
                await axios.post("http://localhost:5522/send_audio", audioData, {
                    headers: {
                        "Content-Type": "application/octet-stream",
                    },
                });
            } catch (error) {
                console.error("Erro ao enviar áudio:", error);
            }
        };
        reader.readAsArrayBuffer(blob);
    };

    const startRecording = () => {
        navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    sendAudioChunk(event.data);
                }
            };

            mediaRecorder.start(1000); // Collect 1-second chunks of audio
            setRecording(true);
        });
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);
        }
    };

    return (
        <div>
            <Typography variant="h4" component="h1" gutterBottom>
                Prontuário com IA (Assíncrono)
            </Typography>
            <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
                <div className="recorder">
                    <Typography variant="body1">
                        {recording ? "Gravando..." : "Pronto para gravar"}
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<MicIcon />}
                        onClick={startRecording}
                        disabled={recording}
                        className="record-button"
                        style={{ marginRight: '10px' }}
                    >
                        Iniciar Gravação
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<StopIcon />}
                        onClick={stopRecording}
                        disabled={!recording}
                        className="record-button"
                    >
                        Parar Gravação
                    </Button>
                </div>
            </Paper>
            {loading && <CircularProgress />}
            <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
                <Typography variant="h5">Texto Capturado:</Typography>
                <Typography variant="body1">{transcription}</Typography>
            </Paper>
            <Paper elevation={3} style={{ padding: '20px' }}>
                <Typography variant="h5">Sumário:</Typography>
                <div dangerouslySetInnerHTML={{ __html: summary }} />
            </Paper>
        </div>
    );
}

export default ProntuarioAsync;
